<template>
  <div v-if="reportName.data != null"> {{ reportName.data }} </div>
  <div v-else> {{ "N/A" }} </div>
</template>

<script>
import ReportServices from '@/services/ReportServices'

export default {
  props: {
    keyname: {
      default: null
    },
    bucket: {
      default: null
    }
  },
  data () {
    return {
      reportName: 'loading user'
    }
  },
  watch: {
    keyname () {
      this.getReportName(this.bucket, this.keyname)
    }
  },
  methods: {
    async getReportName (bucket, keyname) {
        this.reportName = await ReportServices.getMetadata(bucket, keyname)
    }
  },
  async mounted () {
    await this.getReportName(this.bucket, this.keyname)
  }
}
</script>
